import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import type { Client } from '@bugsnag/js';
import { captureLogRocketException, getLogRocketSessionURL } from '@/services/logrocket.ts';

let bugsnagClient: Client | null = null;

export const startBugsnag = () => {
  if (bugsnagClient) {
    return;
  }

  bugsnagClient = Bugsnag.start({
    appVersion: import.meta.env.VITE_VERSION,
    apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
  });
  BugsnagPerformance.start({
    appVersion: import.meta.env.VITE_VERSION,
    apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
    autoInstrumentRouteChanges: true, // Track route changes automatically
    autoInstrumentNetworkRequests: true, // Track fetch/XHR requests
  });

  getLogRocketSessionURL((sessionURL) => {
    if (!bugsnagClient) {
      return;
    }
    bugsnagClient.addMetadata('logrocket', { sessionURL });
  });
};

export interface ReportErrorParams {
  error: Error;
}
export const reportError = ({ error }: ReportErrorParams) => {
  if (!bugsnagClient) {
    // eslint-disable-next-line no-console
    console.log('No bugsnag client found, printing error');
    // eslint-disable-next-line no-console
    console.error(error);
    return;
  }
  bugsnagClient.notify(
    error
    // (event) => {
    // event.setUser(accountantId);
    // }
  );
  captureLogRocketException({ error });
};
